if (!customElements.get("variant-picker")) {
    class VariantPicker extends HTMLElement {
        constructor() {
            super(),
                (this.section = this.closest(".js-product")),
                (this.productForm = this.section.querySelector(".js-product-form-main")),
                (this.optionSelectors = this.querySelectorAll(".option-selector")),
                (this.data = this.getProductData()),
                (this.variant = this.getSelectedVariant()),
                (this.selectedOptions = this.getSelectedOptions()),
                (this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null),
                this.addEventListener("change", this.handleVariantChange.bind(this)),
                setTimeout(() => {
                    this.updateAvailability(), this.updateAddToCartButton();
                });
        }
        handleVariantChange(evt) {
            (this.selectedOptions = this.getSelectedOptions()),
                (this.variant = this.getSelectedVariant()),
                (this.preSelection = !this.variant && this.selectedOptions.find((o) => o === null) === null),
                this.variant && (this.updateMedia(), this.updateUrl(evt), this.updateVariantInput()),
                this.updateAddToCartButton(),
                this.updateAvailability(),
                this.updatePrice(),
                this.updateWeight(),
                this.updateBarcode(),
                this.updateBackorderText(),
                this.updatePickupAvailability(),
                this.updateSku(),
                VariantPicker.updateLabelText(evt),
                this.preSelection ||
                    this.dispatchEvent(
                        new CustomEvent("on:variant:change", {
                            bubbles: !0,
                            detail: { form: this.productForm, variant: this.variant, product: this.data.product },
                        })
                    );
                    location.reload();
               // this.updatePriceSpiderBtn(),
               // this.updateMetafieldVisibility();
        }
        // updatePriceSpiderBtn() {
        //     var metaDivs = document.querySelectorAll(".variant-spider");
        //     metaDivs.forEach(function (div) {
        //         var variantId = div.getAttribute("data-variant-id");
        //         if (variantId === String(this.variant.id)) {
        //             div.style.display = "block";
        //             var metafieldValue = div.textContent.trim();
        //         } else div.style.display = "none";
        //     }, this);
        //     var metaMeet = document.querySelectorAll(".variant-meet-stand");
        //     metaMeet.forEach(function (div) {
        //         var variantId = div.getAttribute("data-variant-id");
        //         if (variantId === String(this.variant.id)) {
        //             div.style.display = "block";
        //             var metafieldValue = div.textContent.trim();
        //         } else div.style.display = "none";
        //     }, this);
        //     var metaDis = document.querySelectorAll(".variant-discontinued");
        //     metaDis.forEach(function (div) {
        //         var variantId = div.getAttribute("data-variant-id");
        //         if (variantId === String(this.variant.id)) {
        //             div.style.display = "block";
        //             var metafieldValue = div.textContent.trim();
        //         } else div.style.display = "none";
        //     }, this);
        //     var metabutton = document.querySelectorAll(".variant-button");
        //     metabutton.forEach(function (div) {
        //         var variantId = div.getAttribute("data-variant-id");
        //         if (variantId === String(this.variant.id)) {
        //             div.style.display = "block";
        //             var metafieldValue = div.textContent.trim();
        //         } else div.style.display = "none";
        //     }, this);
        //     var metaprice = document.querySelectorAll(".variant-price-custom");
        //     metaprice.forEach(function (div) {
        //         var variantId = div.getAttribute("data-variant-id");
        //         if (variantId === String(this.variant.id)) {
        //             div.style.display = "block";
        //             var metafieldValue = div.textContent.trim();
        //             console.log("metafieldValue price", metafieldValue);
        //         } else div.style.display = "none";
        //     }, this);
        // }
        // updateMetafieldVisibility() {
        //     document.querySelectorAll("[data-variant-metafield]").forEach((elem) => {
        //         elem.classList.toggle("hidden", elem.dataset.variantMetafield !== this.variant?.id.toString());
        //     });
        //     var metaDivs = document.querySelectorAll(".variant-meta");
        //     metaDivs &&
        //         metaDivs.forEach(function (div) {
        //             var variantId = div.getAttribute("data-variant-id");
        //             if (variantId === String(this.variant.id)) {
        //                 div.style.display = "block";
        //                 var metafieldValue = div.textContent.trim();
        //             } else div.style.display = "none";
        //         }, this);
        //     var metaDivs_specs = document.querySelectorAll(".variant-meta-specs"),
        //         specLink = document.getElementById("spec-link"),
        //         dropdown = document.querySelector(".pdp-jumplinks-dropdown"),
        //         specOption = dropdown?.querySelector('option[value="#specification-table"]'),
        //         showSpecLink = !1;
        //     if (
        //         (metaDivs_specs.forEach(function (div) {
        //             var variantId = div.getAttribute("data-variant-id");
        //             if (variantId === String(this.variant.id)) {
        //                 div.style.display = "block";
        //                 var metafieldValue = div.textContent.trim();
        //                 showSpecLink = !!metafieldValue;
        //             } else div.style.display = "none";
        //         }, this),
        //         specLink && (specLink.style.display = showSpecLink ? "inline" : "none"),
        //         dropdown)
        //     )
        //         if (showSpecLink) {
        //             if (!specOption) {
        //                 const newSpecOption = document.createElement("option");
        //                 (newSpecOption.value = "#specification-table"),
        //                     (newSpecOption.textContent = "SPECIFICATIONS"),
        //                     dropdown.appendChild(newSpecOption);
        //             }
        //         } else specOption && dropdown.removeChild(specOption);
        //     var metaDivs_features = document.querySelectorAll(".variant-feature-specs"),
        //         featuresLink = document.getElementById("feature-link"),
        //         featureOption = dropdown?.querySelector('option[value="#features-section"]'),
        //         showFeatureLink = !1;
        //     if (
        //         (metaDivs_features.forEach(function (div) {
        //             var variantId = div.getAttribute("data-variant-id");
        //             if (variantId === String(this.variant.id)) {
        //                 div.style.display = "block";
        //                 var metafieldValue = div.textContent.trim();
        //                 showFeatureLink = !!metafieldValue;
        //             } else div.style.display = "none";
        //         }, this),
        //         featuresLink && (featuresLink.style.display = showFeatureLink ? "inline" : "none"),
        //         dropdown)
        //     )
        //         if (showFeatureLink) {
        //             if (!featureOption) {
        //                 const newFeatureOption = document.createElement("option");
        //                 (newFeatureOption.value = "#features-section"),
        //                     (newFeatureOption.textContent = "FEATURES"),
        //                     dropdown.appendChild(newFeatureOption);
        //             }
        //         } else featureOption && dropdown.removeChild(featureOption);
        //     var metaDivs_youmlike = document.querySelectorAll(".variant-meta-youmlike"),
        //         relatedProductsLink = document.getElementById("related-products-link"),
        //         dropdown = document.querySelector(".pdp-jumplinks-dropdown"),
        //         existingOption = dropdown?.querySelector('option[value="#you-may-like"]'),
        //         showYouMayLikeLink = !1;
        //     if (
        //         (metaDivs_youmlike.forEach(function (div) {
        //             var variantId = div.getAttribute("data-variant-id");
        //             if (variantId === String(this.variant.id)) {
        //                 var hasListItem = div.querySelectorAll("li").length > 0;
        //                 (div.style.display = hasListItem ? "block" : "none"), (showYouMayLikeLink = hasListItem);
        //             } else div.style.display = "none";
        //         }, this),
        //         relatedProductsLink && (relatedProductsLink.style.display = showYouMayLikeLink ? "inline" : "none"),
        //         dropdown)
        //     )
        //         if (showYouMayLikeLink) {
        //             if (!existingOption) {
        //                 const newOption = document.createElement("option");
        //                 (newOption.value = "#you-may-like"),
        //                     (newOption.textContent = "YOU MAY LIKE"),
        //                     dropdown.appendChild(newOption);
        //             }
        //         } else existingOption && dropdown.removeChild(existingOption);
        //     var metaDivs_replace = document.querySelectorAll(".variant-meta-replacement"),
        //         replaceProductsLink = document.getElementById("replacement-title"),
        //         showReplaceLink = !1;
        //     metaDivs_replace.forEach(function (div) {
        //         var variantId = div.getAttribute("data-variant-id");
        //         if (variantId === String(this.variant.id)) {
        //             var hasListItem = div.querySelectorAll("li").length > 0;
        //             hasListItem ? (div.style.display = "block") : (div.style.display = "none"),
        //                 (showReplaceLink = hasListItem);
        //         } else div.style.display = "none";
        //     }, this),
        //         replaceProductsLink && (replaceProductsLink.style.display = showReplaceLink ? "inline-block" : "none");
        // }
        updateAddToCartButton() {
            if (
                ((this.productForm = this.section.querySelector(".js-product-form-main")),
                !this.productForm ||
                    ((this.addBtn = this.addBtn || this.productForm.querySelector('[name="add"]')), !this.addBtn))
            )
                return;
            const variantAvailable = this.variant && this.variant.available;
            if (((this.addBtn.disabled = !variantAvailable || this.preSelection), this.preSelection))
                this.addBtn.textContent = theme.strings.noSelectedVariant;
            else {
                const unavailableStr = this.variant ? theme.strings.noStock : theme.strings.noVariant;
                this.addBtn.textContent = variantAvailable ? this.addBtn.dataset.addToCartText : unavailableStr;
            }
        }
        static updateOptionAvailability(optionEl, exists, available) {
            const el = optionEl,
                unavailableText = exists ? theme.strings.noStock : theme.strings.noVariant;
            if (
                (el.classList.toggle("is-unavailable", !available),
                el.classList.toggle("is-nonexistent", !exists),
                optionEl.classList.contains("custom-select__option"))
            ) {
                const em = el.querySelector("em");
                em && (em.hidden = available),
                    available ||
                        (em
                            ? (em.textContent = unavailableText)
                            : (el.innerHTML = `${el.innerHTML} <em class="pointer-events-none">${unavailableText}</em>`));
            } else
                available
                    ? el.nextElementSibling.removeAttribute("title")
                    : (el.nextElementSibling.title = unavailableText);
        }
        updateAvailability() {
            if (this.dataset.showAvailability === "false") return;
            const { availabilityMethod } = this.dataset;
            let currVariant = this.variant;
            this.variant || (currVariant = { options: this.selectedOptions }),
                availabilityMethod === "selection"
                    ? (this.querySelectorAll(".js-option").forEach((optionEl) => {
                          VariantPicker.updateOptionAvailability(optionEl, !1, !1);
                      }),
                      this.optionSelectors.forEach((selector, selectorIndex) => {
                          this.data.product.variants.forEach((variant) => {
                              let matchCount = 0;
                              if (
                                  (variant.options.forEach((option, optionIndex) => {
                                      option === currVariant.options[optionIndex] &&
                                          optionIndex !== selectorIndex &&
                                          (matchCount += 1);
                                  }),
                                  matchCount === currVariant.options.length - 1)
                              ) {
                                  const options = selector.querySelectorAll(".js-option"),
                                      optionEl = Array.from(options).find((opt) =>
                                          selector.dataset.selectorType === "dropdown"
                                              ? opt.dataset.value === variant.options[selectorIndex]
                                              : opt.value === variant.options[selectorIndex]
                                      );
                                  optionEl && VariantPicker.updateOptionAvailability(optionEl, !0, variant.available);
                              }
                          });
                      }))
                    : this.optionSelectors.forEach((selector, selectorIndex) => {
                          selector.querySelectorAll('.js-option:not([data-value=""])').forEach((option) => {
                              const optionValue =
                                  selector.dataset.selectorType === "dropdown" ? option.dataset.value : option.value;
                              let variantsExist = !1,
                                  variantsAvailable = !1;
                              this.data.product.variants.forEach((v) => {
                                  let matches = 0;
                                  for (let i = 0; i < selectorIndex; i += 1)
                                      (v.options[i] === this.selectedOptions[i] || this.selectedOptions[i] === null) &&
                                          (matches += 1);
                                  v.options[selectorIndex] === optionValue &&
                                      matches === selectorIndex &&
                                      ((variantsExist = !0), v.available && (variantsAvailable = !0));
                              }),
                                  VariantPicker.updateOptionAvailability(option, variantsExist, variantsAvailable);
                          });
                      });
        }
        updateBackorderText() {
            if (((this.backorder = this.backorder || this.section.querySelector(".backorder")), !this.backorder))
                return;
            let hideBackorder = !0;
            if (this.variant && this.variant.available) {
                const { inventory } = this.data.formatted[this.variant.id];
                if (this.variant.inventory_management && inventory === "none") {
                    const backorderProdEl = this.backorder.querySelector(".backorder__product"),
                        prodTitleEl = this.section.querySelector(".product-title"),
                        variantTitle = this.variant.title.includes("Default") ? "" : ` - ${this.variant.title}`;
                    (backorderProdEl.textContent = `${prodTitleEl.textContent}${variantTitle}`), (hideBackorder = !1);
                }
            }
            this.backorder.hidden = hideBackorder;
        }
        static updateLabelText(evt) {
            const selector = evt.target.closest(".option-selector");
            if (selector.dataset.selectorType === "dropdown") return;
            const colorText = selector.querySelector(".js-color-text");
            colorText && (colorText.textContent = evt.target.nextElementSibling.querySelector(".js-value").textContent);
        }
        updateMedia() {
            if (this.variant.featured_media)
                if (this.section.matches("quick-add-drawer")) this.section.updateMedia(this.variant.featured_media.id);
                else {
                    if (
                        ((this.mediaGallery = this.mediaGallery || this.section.querySelector("media-gallery")),
                        !this.mediaGallery)
                    )
                        return;
                    const variantMedia = this.mediaGallery.querySelector(
                        `[data-media-id="${this.variant.featured_media.id}"]`
                    );
                    this.mediaGallery.setActiveMedia(variantMedia, !0, !0);
                }
        }
        updatePickupAvailability() {
            (this.pickUpAvailability = this.pickUpAvailability || this.section.querySelector("pickup-availability")),
                this.pickUpAvailability &&
                    (this.variant && this.variant.available
                        ? this.pickUpAvailability.getAvailability(this.variant.id)
                        : (this.pickUpAvailability.removeAttribute("available"),
                          (this.pickUpAvailability.innerHTML = "")));
        }
        updatePrice() {
            if (((this.price = this.price || this.section.querySelector(".product-info__price > .price")), !this.price))
                return;
            let { variant } = this;
            if (!variant.available && variant.price === 0) {
                this.price.style.display = "none";
                return;
            } else this.price.style.display = "block";
            if (this.preSelection) {
                variant = this.data.product.variants[0];
                for (let i = 1; i < this.data.product.variants.length; i += 1)
                    this.data.product.variants[i].price < variant.price && (variant = this.data.product.variants[i]);
            }
            if (this.variant) {
                const priceCurrentEl = this.price.querySelector(".price__current"),
                    priceWasEl = this.price.querySelector(".price__was"),
                    unitPriceEl = this.price.querySelector(".unit-price");
                if (
                    ((priceCurrentEl.innerHTML = this.data.formatted[this.variant.id].price),
                    priceWasEl && (priceWasEl.innerHTML = this.data.formatted[this.variant.id].compareAtPrice || ""),
                    this.variant.unit_price_measurement)
                ) {
                    const valueEl = this.price.querySelector(".unit-price__price"),
                        unitEl = this.price.querySelector(".unit-price__unit"),
                        value = this.variant.unit_price_measurement.reference_value,
                        unit = this.variant.unit_price_measurement.reference_unit;
                    (valueEl.innerHTML = this.data.formatted[this.variant.id].unitPrice),
                        (unitEl.textContent = value === 1 ? unit : `${value} ${unit}`);
                }
                (unitPriceEl.hidden = !this.variant.unit_price_measurement),
                    this.price.classList.toggle("price--on-sale", this.variant.compare_at_price > this.variant.price),
                    this.price.classList.toggle("price--sold-out", !this.variant.available && !this.preSelection);
            }
            (this.price.querySelector(".price__default").hidden = !this.variant && !this.preSelection),
                (this.price.querySelector(".price__no-variant").hidden = this.variant || this.preSelection);
            const from = this.price.querySelector(".price__from");
            from && (from.hidden = !this.preSelection);
        }
        updateWeight() {
            if (
                ((this.weights = this.weights || this.section.querySelectorAll(".product-info__weight")),
                this.weights.length === 0)
            )
                return;
            const weightAvailable = this.variant && this.variant.weight > 0;
            this.weights.forEach((weight) => {
                (weight.textContent = weightAvailable ? this.data.formatted[this.variant.id].weight : ""),
                    (weight.hidden = !weightAvailable);
            });
        }
        updateBarcode() {
            if (
                ((this.barcodes = this.barcodes || this.section.querySelectorAll(".product-info__barcode-value")),
                this.barcodes.length === 0)
            )
                return;
            const barcodeAvailable = this.variant && this.variant.barcode;
            this.barcodes.forEach((barcode) => {
                (barcode.textContent = barcodeAvailable ? this.variant.barcode : ""),
                    (barcode.parentNode.hidden = !barcodeAvailable);
            });
        }
        updateSku() {
            if (((this.sku = this.sku || this.section.querySelector(".product-sku__value")), !this.sku)) return;
            const skuAvailable = this.variant && this.variant.sku;
            (this.sku.textContent = skuAvailable ? this.variant.sku : ""), (this.sku.parentNode.hidden = !skuAvailable);
        }
        updateUrl(evt) {
            !evt ||
                evt.type !== "change" ||
                this.dataset.updateUrl === "false" ||
                window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.variant.id}`);
        }
        updateVariantInput() {
            (this.forms = this.forms || this.section.querySelectorAll(".js-product-form-main, .js-instalments-form")),
                this.forms.forEach((form) => {
                    const input = form.querySelector('input[name="id"]');
                    (input.value = this.variant.id), input.dispatchEvent(new Event("change", { bubbles: !0 }));
                });
        }
        getSelectedOptions() {
            const selectedOptions = [];
            return (
                this.optionSelectors.forEach((selector) => {
                    if (selector.dataset.selectorType === "dropdown") {
                        const selectedItem = selector
                                .querySelector('ul[role="listbox"]')
                                .querySelector('[aria-selected="true"]'),
                            fullValue = selectedItem ? selectedItem.dataset.value : null;
                        selectedOptions.push(fullValue === this.dataset.placeholderText ? null : fullValue);
                    } else {
                        const selected = selector.querySelector("input:checked");
                        selectedOptions.push(selected ? selected.value : null);
                    }
                }),
                selectedOptions
            );
        }
        getProductData() {
            const dataEl = this.querySelector('[type="application/json"]');
            return JSON.parse(dataEl.textContent);
        }
        getSelectedVariant() {
            const selectedOptions = this.getSelectedOptions();
            return this.data.product.variants.find((v) =>
                v.options.every((val, index) => val === selectedOptions[index])
            );
        }
    }
    customElements.define("variant-picker", VariantPicker);
}
//# sourceMappingURL=/s/files/1/0929/5911/3490/t/6/assets/variant-picker.js.map?v=1750238083
